import Box from "../../../components/utility/box";
import CreateTaskFooter from "../../ScrumBoard/Task/TaskCreateOrUpdate/CreateTaskFooter/CreateTaskFooter";
import CreateTaskHeader from "../../ScrumBoard/Task/TaskCreateOrUpdate/CreateTaskHeader/CreateTaskHeader";
import {
    SelectOption as Option,
} from '@iso/components/uielements/select';
import Select from '../../Deployments/Deployment.styles';
import { useContext, useEffect, useRef, useState } from "react";
import api from "../../../api";
import { Button, Calendar, TimePicker, Spin, Tag } from 'antd';
import { setDay } from "date-fns";
import { AppContext } from "../../../context/ContextProvider";
import scanNow from '../../../assets/images/scanNow.svg';
import scheduleLater from '../../../assets/images/scheduleLater.svg';
import { AlertContext } from "../../../context/alertContext";
import { formatErrors } from "../../../context/helper";
import { CustomModal } from "../CustomComponents/PageLoader.style";
import noDataPlusIcon from '@iso/assets/images/nodata-plus-icon.svg';
import noDataImg from '@iso/assets/images/no-data-found.svg';
import { useNavigate } from "react-router";

const MAX_REGIONS = 3;


const noDataTitle = {
    color: "#A6A6A6",
    textAlign: "center",
    fontFamily: "Nunito Sans",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "300",
};

const noDataSubTitle = {
    color: "#323232",
    fontFamily: "Poppins",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "400",
    marginLeft: "5px"
};

const titleStyle = {
    color: "#1f1f1f",
    fontFamily: "Poppins",
    fontSize: "14px",
    fontWeight: "500"
};

const subTitleStyle = {
    color: "#9b9b9b",
    fontFamily: "Nunito Sans",
    fontSize: "12px",
    fontWeight: "400"
};
export default function SecurityTypeDrawerData() {

    const navigate = useNavigate();

    const [accountList, setAccountList] = useState([]);
    const [accountsPageCount, setAccountsPageCount] = useState(1);
    const [doneFetchingAccounts, setDoneFetchingAccounts] = useState(false);
    const [accountsFetching, setAccountsFetching] = useState(false);
    const PAGE_SIZE_ACCOUNTS = 10;
    // Running count of how many accounts actually rendered as options after the
    // client-side active-integration filter. Used to decide whether the dropdown
    // is tall enough to scroll (and therefore trigger onPopupScroll for the next page).
    const visibleAccountsCountRef = useRef(0);
    const [typeList, setTypeList] = useState([]);
    const [freqs, setFreqs] = useState([]);
    const [daysList, setDaysList] = useState([]);
    //const [freqSelected, setFreqSelected] = useState("");
    const [selectedData, setSelectedData] = useState({
        accountNo: "",
        type: "",
        frequency: "",
        dailyTime: "",
        weeklyTime: "",
        weeklyDay: "",
        monthlyPeriod: "",
        monthlyTime: ""
    });
    const [selectedRegions, setSelectedRegions] = useState([]);
    const [activeRegionsData, setActiveRegionsData] = useState(null);
    const [loadingRegions, setLoadingRegions] = useState(false);
    const { openRightDrawer, setOpenRightDrawer, refreshBoardList, setRefreshBoardList, dispatch } = useContext(AppContext);
    const [scanType, setScanType] = useState("Scan Now");
    const { alertOptions, set_alertOptions } = useContext(AlertContext);
    const [error, setError] = useState({
        status: false,
        msg: ""
    });

    // Clear the validation error once at least one region is selected
    // (covers both the dropdown and the quick-select tags).
    useEffect(() => {
        if (selectedRegions.length > 0) {
            setError(prev => prev.status ? { status: false, msg: "" } : prev);
        }
    }, [selectedRegions]);
    console.log("Scan types: ", scanType);

    console.log("This component executed");
    useEffect(() => {
        if (accountsPageCount === 1) {
            setAccountList([]);
            setDoneFetchingAccounts(false);
            visibleAccountsCountRef.current = 0;
        }
        setAccountsFetching(true);
        const url = `${process.env.REACT_APP_API_URI}/api/integration/account/list/?from_integrationlist=false&page=${accountsPageCount}&page_size=${PAGE_SIZE_ACCOUNTS}`;
        api.post(url, { category_id: 1, is_active: true })
            .then((res) => {
                let data = res.data;
                let options = [];
                if (data.status && data.data?.results) {
                    const results = data.data.results;
                    results.forEach((child) => {
                        if (child.integration_state && child.integration_state.toLowerCase() === "active" && child.integration === 1) {
                            options.push(<Option key={child.account_id} name="accountNo" value={child.account_id}>
                                <div style={{ display: "flex", justifyContent: "start", alignItems: "center", width: "100%" }}>
                                    <img src={child.integration_logo} style={{ width: "18px", height: "18px", marginRight: "10px" }} alt="provider" />
                                    <span>{`${child.account_id}${child.alias ? ` (${child.alias})` : ""}`}</span>
                                </div>
                            </Option>);
                        }
                    });

                    // Prefer the server's pagination cursor; fall back to the page-size
                    // heuristic when `next` isn't present in the payload.
                    const isLastPage = data.data.next == null || results.length < PAGE_SIZE_ACCOUNTS;
                    if (isLastPage) {
                        setDoneFetchingAccounts(true);
                    }

                    visibleAccountsCountRef.current += options.length;
                    setAccountList((prev) => accountsPageCount <= 1 ? options : [...prev, ...options]);

                    // The list is filtered client-side, so a page can yield only a few
                    // (or zero) visible options — leaving the dropdown too short to scroll.
                    // When that happens onPopupScroll never fires and the later pages
                    // (which may hold the account the user wants) are never requested.
                    // Keep pulling pages until we have enough options to make the dropdown
                    // scrollable, or we've run out of pages; scroll takes over after that.
                    if (!isLastPage && visibleAccountsCountRef.current < PAGE_SIZE_ACCOUNTS) {
                        setAccountsPageCount((prev) => prev + 1);
                    }
                }
            })
            .catch((err) => console.log('Error :', err))
            .finally(() => setAccountsFetching(false));
    }, [accountsPageCount]);

    // Fetch active regions when account changes
    useEffect(() => {
        if (selectedData.accountNo) {
            setLoadingRegions(true);
            setSelectedRegions([]);
            setActiveRegionsData(null);
            api.get(process.env.REACT_APP_API_URI + `/api/cluster/prowler/scan/?get_active_regions=true&account_id=${selectedData.accountNo}`)
                .then((res) => {
                    const respData = res.data?.data || res.data;
                    if (respData.active_regions) {
                        setActiveRegionsData(respData.active_regions);
                    }
                    setLoadingRegions(false);
                })
                .catch((err) => {
                    console.log("Error fetching active regions:", err);
                    setLoadingRegions(false);
                });
        } else {
            setActiveRegionsData(null);
            setSelectedRegions([]);
        }
    }, [selectedData.accountNo]);

    useEffect(() => {
        const types = [
            { value: "cislevel1", label: "CIS Level 1" },
            { value: "cislevel2", label: "CIS Level 2" },
            { value: "pci", label: "PCI DSS" },
            { value: "soc2", label: "SOC 2" },
            { value: "hipaa", label: "HIPAA" },
        ];
        let data = [];

        types.map((item) => {
            data.push(<Option key={item.value} name="type" value={item.value}>{item.label}</Option>);
        });

        setTypeList(data);
    }, []);

    useEffect(() => {
        const freqTypes = ["Monthly", "Weekly", "Daily"];
        const freqOptions = [];
        freqTypes.map((val) => {
            freqOptions.push(<Option key={val} name="frequency" value={val}>{val}</Option>)
        });
        setFreqs(freqOptions);

        const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        setDaysList(days);
    }, []);

    function toggleAlert(type, message, description, hide = true, time = 5) {
        set_alertOptions(alertOptions => ({
            status: true,
            type: type,
            message: message,
            description: description,
        }));

        console.log("Hide :", hide);
        console.log("time :", time);
        if (hide) {
            // opacity=0 after 10sec
            setTimeout(() => {
                set_alertOptions(alertOptions => ({
                    status: false,
                    type: type,
                    message: message,
                    description: description,
                }));
            }, time * 1000);
        }
    }

    const handleRegionChange = (values) => {
        if (values.length > MAX_REGIONS) {
            toggleAlert("warning", "Warning", `You can select a maximum of ${MAX_REGIONS} regions.`);
            return;
        }
        setSelectedRegions(values);
    };

    const handleScan = () => {
        if (scanType === "Scan Now") {
            dispatch({ loader: "scan", status: "loading", nestLevel: 2 });

            if (selectedData.accountNo !== "" && selectedData.type !== "" && selectedRegions.length > 0) {
                const payload = {
                    account_id: selectedData.accountNo,
                    scan_type: selectedData.type,
                    regions: selectedRegions,
                };
                api.post(process.env.REACT_APP_API_URI + '/api/cluster/prowler/scan/', payload).then((res) => {
                    let data = res.data;
                    if (data.status) {
                        toggleAlert("success", "Success", "Scan request has been initiated.");
                        setOpenRightDrawer({
                            drawerType: false,
                        });
                        setRefreshBoardList(!refreshBoardList);
                    }
                    else if (!data.status) {
                        const rawErr = formatErrors(data.error_details);
                        console.log("err in security scan :", rawErr);
                        const userMessage = data.message || "Failed to initiate scan. Please try again later.";
                        setOpenRightDrawer({
                            drawerType: false,
                        });
                        toggleAlert("error", "Error", userMessage);
                    }

                    dispatch({ loader: "scan", status: "loaded", nestLevel: 2 });
                }).catch((err) => {
                    console.log("Error: ", err);
                    dispatch({ loader: "scan", status: "loaded", nestLevel: 2 });
                    toggleAlert("error", "Error", "An error occurred.");
                });
            }
            else {
                dispatch({ loader: "scan", status: "loaded", nestLevel: 2 });
                const missing = [];
                if (selectedData.accountNo === "") missing.push("an Account");
                if (selectedData.type === "") missing.push("a Type");
                if (selectedRegions.length === 0) missing.push("at least one Region");
                const missingText = missing.length > 1
                    ? `${missing.slice(0, -1).join(", ")} and ${missing[missing.length - 1]}`
                    : missing[0];
                setError({
                    status: true,
                    msg: `Please select ${missingText} to proceed.`
                });
            }
        }
        else {

        }
    };
    const handleClear = () => {
        console.log("Clearing");
        setSelectedData({
            accountNo: "",
            type: "",
            frequency: "",
            dailyTime: "",
            weeklyTime: "",
            weeklyDay: "",
            monthlyPeriod: "",
            monthlyTime: ""
        });
        setSelectedRegions([]);
        setActiveRegionsData(null);
        setError({
            status: false,
            msg: ""
        });
    };

    const handleAccountsPopupScroll = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
        if (!doneFetchingAccounts && (scrollHeight - scrollTop <= clientHeight + 10) && !accountsFetching) {
            setAccountsPageCount((prev) => prev + 1);
            setAccountsFetching(true);
        }
    };

    const handleSelectChange = (value, event) => {
        if(event.name === "redirect"){
            setOpenRightDrawer({
                drawerType: false,
            });
            navigate("/integrations");
        }

        console.log("Enters");
        setError({
            status: false,
            msg: ""
        })
        setSelectedData(selectedData => ({
            ...selectedData,
            [event.name]: value
        }));
    };

    const onPanelChange = (value, mode) => {

    };
    const handleDayClick = (val) => {
        setSelectedData(selectedData => ({
            ...selectedData,
            weeklyDay: val
        }));
    };
    return (
        <>
            {/* <CustomModal
                visible={fetching}
                //onCancel={hideModal}
                footer={null}
                closable={false}
                centered
                maskClosable={false}
                style={{ border: "none", boxShadow: "none" }}
            >
                <div style={{ textAlign: 'center', background: "transparent", border: "none" }}>
                    <Spin size="large" />
                </div>
            </CustomModal> */}

            <CreateTaskHeader buttonContent={"Scan"} onCancel={() => {
                setOpenRightDrawer({
                    drawerType: false,
                });
            }} />
            
            <Box style={{ display: "flex", height: "fit-content", margin: "83px 0 0 0", border: "0", padding: "0" }}>
                <Box
                    title={
                        <div style={{ display: "flex" }}>
                            <img src={scanNow} style={{ marginRight: "10px" }} />
                            <p> Scan Now </p>
                        </div>
                    }
                    style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "fit-content", backgroundColor: scanType === "Scan Now" ? "#f4fbff" : "", cursor: "pointer", marginBottom: "0" }}
                    onClick={() => {
                        setScanType("Scan Now");
                    }}
                />
                <Box
                    title={
                        <div style={{ display: "flex" }}>
                            <img src={scheduleLater} style={{ marginRight: "10px" }} />
                            <p> Schedule Later </p>
                        </div>
                    }
                    style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "fit-content", backgroundColor: scanType === "Schedule Later" ? "#f4fbff" : "", cursor: "pointer", marginBottom: "0", cursor: "not-allowed" }}
                    onClick={() => {
                        // setScanType("Schedule Later");
                    }}
                />
            </Box>
            <Box title="Account*" subtitle="Please select an account" titleStyle={titleStyle} subTitleStyle={subTitleStyle} style={{ border: "0", height: "fit-content", padding: "40px 40px 0 40px" }}>
                <Select
                    placeholder="Select account number"
                    style={{ width: "100%" }}
                    value={selectedData.accountNo === "" ? null : selectedData.accountNo}
                    onChange={handleSelectChange}
                    onPopupScroll={handleAccountsPopupScroll}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    dropdownRender={(menu) => (
                        <div>
                            {accountList.length === 0 && accountsFetching ? (
                                <div style={{ textAlign: 'center', padding: 8 }}>
                                    <Spin size="small" />
                                </div>
                            ) : (menu)}
                            {!doneFetchingAccounts && accountList.length > 0 && accountsFetching && (
                                <div style={{ textAlign: 'center', padding: 6 }}>
                                    <Spin size="small" />
                                </div>
                            )}
                        </div>
                    )}
                >
                    {accountList.length > 0 ? accountList :
                        !accountsFetching ? (
                            <Option key="0" name="redirect" data-alias="" type="integration" style={{background: "white"}}>
                                <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "center", height: "fit-content", padding: "3px 0" }}>
                                    <img src={noDataImg} />
                                    <span style={noDataTitle}>No Account available.</span>
                                    <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                                        <img src={noDataPlusIcon} />
                                        <span style={noDataSubTitle}>Create one</span>
                                    </div>
                                </div>
                            </Option>
                        ) : (
                            <Option key="accounts-loader">
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "40px" }}>
                                    <Spin size="small" />
                                </div>
                            </Option>
                        )
                    }
                </Select>
            </Box>
            <Box title="Type*" subtitle="Please select scan framework type" titleStyle={titleStyle} subTitleStyle={subTitleStyle} style={{ border: "0", height: "fit-content", padding: "40px 40px 0 40px" }}>
                <Select placeholder="Select" style={{ width: "100%" }} value={selectedData.type === "" ? null : selectedData.type} onChange={handleSelectChange}>{typeList}</Select>

                {error.status && !Array.isArray(error.msg) && !(selectedData.accountNo && selectedData.type) && <p className="isoHelperText">
                    <span>{error.msg}</span>
                </p>}
            </Box>
            {scanType === "Scan Now" ? (
                <>
                    {selectedData.accountNo && selectedData.type && (
                        <Box
                            title="Regions*"
                            subtitle={`Select up to ${MAX_REGIONS} regions to scan. Scanning all regions may timeout due to session limits.`}
                            titleStyle={titleStyle}
                            subTitleStyle={subTitleStyle}
                            style={{ border: "0", height: "fit-content", padding: "40px 40px 0 40px", marginBottom: "120px" }}
                        >
                            {loadingRegions ? (
                                <div style={{ textAlign: "center", padding: "10px 0" }}>
                                    <Spin size="small" />
                                    <span style={{ marginLeft: "8px", color: "#9b9b9b", fontSize: "12px" }}>Loading active regions...</span>
                                </div>
                            ) : (
                                <>
                                    <Select
                                        mode="multiple"
                                        placeholder="Select regions to scan"
                                        style={{ width: "100%" }}
                                        value={selectedRegions}
                                        onChange={handleRegionChange}
                                        maxTagCount="responsive"
                                        maxTagPlaceholder={(omitted) => `+${omitted.length} more`}
                                        showSearch
                                        optionFilterProp="children"
                                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                    >
                                        {(activeRegionsData?.auto_detected || []).map((info) => {
                                            const region = info.region;
                                            const spend = ` - $${parseFloat(info.spend || 0).toFixed(2)}`;
                                            return (
                                                <Option key={region} value={region}>
                                                    <span style={{ color: "#1890ff", fontWeight: 500 }}>&#9679; {region}</span>
                                                    <span style={{ color: "#52c41a", fontSize: "11px", marginLeft: "6px" }}>Active{spend}</span>
                                                </Option>
                                            );
                                        })}
                                    </Select>
                                    {error.status && !Array.isArray(error.msg) && <p className="isoHelperText">
                                        <span>{error.msg}</span>
                                    </p>}
                                    {activeRegionsData && activeRegionsData.auto_detected && activeRegionsData.auto_detected.length > 0 && (
                                        <div style={{ marginTop: "8px" }}>
                                            <span style={{ fontSize: "11px", color: "#9b9b9b" }}>Quick select active regions: </span>
                                            {activeRegionsData.auto_detected.map((r) => (
                                                <Tag
                                                    key={r.region}
                                                    color={selectedRegions.includes(r.region) ? "green" : "blue"}
                                                    style={{ cursor: "pointer", fontSize: "11px", marginTop: "4px" }}
                                                    onClick={() => {
                                                        if (selectedRegions.includes(r.region)) {
                                                            setSelectedRegions(selectedRegions.filter(reg => reg !== r.region));
                                                        } else if (selectedRegions.length < MAX_REGIONS) {
                                                            setSelectedRegions([...selectedRegions, r.region]);
                                                        }
                                                    }}
                                                >
                                                    {r.region}
                                                </Tag>
                                            ))}
                                        </div>
                                    )}
                                </>
                            )}
                        </Box>
                    )}
                </>) : scanType === "" ? <></> : (<>
                    {/* <Box title="Account*" subtitle="Please select an account" titleStyle={titleStyle} subTitleStyle={subTitleStyle} style={{ marginTop: "80px", border: "0", height: "fit-content", padding: "40px 40px 0 40px" }}>
                        <Select placeholder="Select" style={{ width: "100%" }}>{accountList}</Select>
                    </Box>
                    <Box title="Type" subtitle="Please select scan framework type" titleStyle={titleStyle} subTitleStyle={subTitleStyle} style={{ border: "0", height: "fit-content", padding: "40px 40px 0 40px" }}>
                        <Select placeholder="Select" style={{ width: "100%" }}></Select>
                    </Box> */}
                    <Box title="Frequency*" subtitle="Please select frequency" titleStyle={titleStyle} subTitleStyle={subTitleStyle} style={{ border: "0", height: "fit-content", padding: "40px 40px 0 40px" }}>
                        <Select placeholder="Select" style={{ width: "100%" }} onChange={handleSelectChange}>{freqs}</Select>
                    </Box>

                    {selectedData.frequency === "Daily" && <>
                        <Box title="Specify time period*" subtitle="Please choose specific time period" titleStyle={titleStyle} subTitleStyle={subTitleStyle} style={{ border: "0", height: "fit-content", padding: "40px 40px 0 40px" }}>
                            <TimePicker style={{ height: "44px", width: "100%" }} />
                        </Box>
                    </>}
                    {selectedData.frequency === "Weekly" && <>
                        <Box title="Choose specific day*" subtitle="Please choose specific day" titleStyle={titleStyle} subTitleStyle={subTitleStyle} style={{ border: "0", height: "fit-content", padding: "40px 40px 0 40px" }}>
                            <div style={{ border: "1px solid #d0d5dd", borderRadius: "2px", width: "fit-content" }}>
                                {daysList.map((val, idx) => {
                                    return (<Button style={{ border: "0", borderRight: idx < 6 ? "1px solid #d0d5dd" : "0", borderRadius: "0" }} onClick={() => {
                                        handleDayClick(val);
                                    }}>{val}</Button>);
                                })}
                            </div>
                        </Box>
                        <Box title="Choose specific period*" subtitle="Please choose specific time period" titleStyle={titleStyle} subTitleStyle={subTitleStyle} style={{ border: "0", height: "fit-content", padding: "40px 40px 0 40px" }}>
                            <TimePicker style={{ height: "44px", width: "100%" }} />
                        </Box>
                    </>}
                    {selectedData.frequency === "Monthly" && <>
                        <Box title="Choose specific period*" subtitle="Please choose specific period" titleStyle={titleStyle} subTitleStyle={subTitleStyle} style={{ border: "0", height: "fit-content", padding: "40px 40px 0 40px" }}>
                            <Calendar fullscreen={false} onPanelChange={onPanelChange} bordered={true} style={{ border: "1px solid lightgray" }} />
                        </Box>
                        <Box title="Specify time period*" subtitle="Please choose specific time period" titleStyle={titleStyle} subTitleStyle={subTitleStyle} style={{ border: "0", height: "fit-content", padding: "40px 40px 0 40px", marginBottom: "180px" }}>
                            <TimePicker style={{ height: "44px", width: "100%" }} />
                        </Box>
                    </>}
                </>)}
            <CreateTaskFooter buttonContent={scanType} openDrawer={() => { }} givenButtonFunction1={handleScan} givenButtonFunction2={handleClear} />
        </>
    );
}